module.exports = __webpack_public_path__ + "static/img/2.3d3db15.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.png
// module id = B8sb
// module chunks = 1